import React from "react";
import {
  getPlaceholderForNumberFieldConfiguration, hasBeenFilled,
} from "../../../../helpers/dynamicFormHelper";
import {NumberSearchFieldType} from "../../../../types/configurations";
import InputNumber from "../../inputs/InputNumber";
import { FormikProps } from "formik/dist/types";

interface PropsType {
  fieldConfigurations: NumberSearchFieldType,
  disabled: boolean,
  forceDisabled: boolean,
  changeFilterDispatchActionHandler: any,
  formProps: FormikProps<any>
}

const NumberSearchField = (props: PropsType) => {
  const {
    fieldConfigurations,
    disabled,
    forceDisabled,
    changeFilterDispatchActionHandler,
    formProps: {
      values
    }
  } = props;

  const value = values[fieldConfigurations.name];
  const isInputDisabled = forceDisabled || (disabled && hasBeenFilled(value));

  return (
    <InputNumber
      className="m-0 form-control"
      value={value}
      disabled={isInputDisabled}
      min={fieldConfigurations.minValue}
      max={fieldConfigurations.maxValue}
      step={fieldConfigurations.step}
      placeholder={getPlaceholderForNumberFieldConfiguration(fieldConfigurations)}
      name={fieldConfigurations.name}
      onChange={(newValue) => {
        changeFilterDispatchActionHandler(fieldConfigurations.name, newValue);
      }}
      onClear={() => {
        changeFilterDispatchActionHandler(fieldConfigurations.name, null);
      }}
    />
  );
};

export default NumberSearchField;
